import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { TipoDocumento } from 'src/app/Models/tipodocumento/tipo-documento';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { ClienteDireccion } from 'src/app/Models/cliente/clientedireccion/cliente-direccion';
import { FindValueSubscriber } from 'rxjs/internal/operators/find';


@Component({
    selector: 'app-cliente-edit',
    templateUrl: './cliente-edit.component.html',
    styleUrls: ['./cliente-edit.component.css']
})
export class ClienteEditComponent implements OnInit {
    @ViewChild('btnshowcli', null) btnshowart: ElementRef;
    @ViewChild('btnclosecli', null) btnclosepg: ElementRef;
    @ViewChild('cliloading', null) cliloading: LoadingComponent;
    @ViewChild('cliinfo', null) cliinfo: InfoComponent;

    public funcion: Function;
    public isShow: boolean = false;
    public iseditable: boolean = false;
    public cliente: Cliente = new Cliente();
    public wait = { tipodocumento: false };
    public pgdirecc:any;
    public tipodocumentos: TipoDocumento[] = [];
    public zonas: any[] = [];
    public tiposclientes: any[] = [];
    public mldocumento:number = 30;
    public isbtnvalida:boolean = true;
    public isbtnsunat:boolean= false;
    public isdisabled:boolean= true;
    public isdisabled_documento = true;
    public clientedireccion:ClienteDireccion = new ClienteDireccion();
    public clientedirecciones:ClienteDireccion[] = [];
    public lbltitulo:string='Crear Nuevo Cliente';
    constructor(private data: DataService, private notify: NotifyService) { }
    ngOnInit() {

    }
    public async show(affterfunction: Function = null) {
        this.funcion = affterfunction;
        this.isShow = true;
        await this.getTipoDocumento();
        await this.GetZonasUbigeo();
        await this.GetTiposCliente();
        setTimeout(async () => {
            this.btnshowart.nativeElement.click();
            this.cliloading.show('Cargando datos');
            this.cliloading.hide();
            if(this.iseditable){
                this.isdisabled = false;
                this.isbtnvalida = false;
                this.isbtnsunat = false;
                this.lbltitulo = 'Modificar cliente CD:'+ this.cliente.documento;
            }
        }, 10);


    }

    
    async getTipoDocumento(){
        this.wait.tipodocumento = true;
        await this.data.AsyncGetSimple(this.data.api.tipodocumento).then(r =>{
            this.wait.tipodocumento = false;
            console.log(this.cliente);
            this.tipodocumentos = r;
            
        });
    }

    async GetZonasUbigeo(){
        await this.data.AsyncGetSimple(this.data.api.ubicacion).then(r =>{

            this.zonas = r;
            console.log(this.zonas);
        });
    }

    async GetTiposCliente() {
        await this.data.AsyncGetSimple("tipocliente").then(r => {
            console.log(r);
            this.tiposclientes = r;
            console.log(this.tiposclientes);
        });
    }

    public async VerficarDoc(){
        console.log(this.cliente.documento);
    }
    public setMaxLengthDoc(){
        let a = this.tipodocumentos.find(e=>(e.codigo == this.cliente.tipodocide));
        if(a!= undefined){
            
            this.mldocumento = parseInt(a.longitud);
            this.isbtnvalida=true;
            this.isdisabled = true;
            this.isdisabled_documento = false;
        }
    }
    public disable_edit():string{ return ((this.iseditable) ? 'true':'false');}
    public disabled_documento():string{ return ((this.isdisabled_documento) ? 'true':'false');  }
    public disabled_form():string{ return (this.isdisabled? 'true':'false'); }
    public disabled_btnvalidate():string{ return (this.validate_length_documento(true)? null:'true'); }
    public disabled_btndireccion():string{
       
        return (this.data.isset(this.cliente.tipodocide) && this.data.isset(this.cliente.documento) && this.data.isset(this.cliente.nombre) && this.data.isset(this.cliente.direccion) ? null : 'true');
    }
    public validate_length_documento(usedisabled:boolean=false){

        if(this.cliente.documento != undefined){
           
            if(parseInt(this.cliente.tipodocide) == 1){
                if(this.cliente.documento.length >= 8){ return true; }
                else{ if(!usedisabled){this.data.notify('Estimado(a), ingrese un número de documento (DNI) válido. (8 dígitos)','Advertencia',this.data.alertType.warning,new ALertOption(false,false,'Aceptar'));} return false; }
            }else if(parseInt(this.cliente.tipodocide) == 6){
                if(this.cliente.documento.length >= 11){ return true; }
                else{ if(!usedisabled){this.data.notify('Estimado(a), ingrese un número de documento (RUC) válido. (11 dígitos)','Advertencia',this.data.alertType.warning,new ALertOption(false,false,'Aceptar'));} return false; }
            }else{
                return true;
            }
        }else{return false;}
    }
    /*buscar cliente en la sunat */
    public async searchClientBD(){
        let a = this.tipodocumentos.find(e=>(e.codigo == this.cliente.tipodocide));
        if(a!= undefined){
            if(this.data.isset(this.cliente.documento)){
                if(this.validate_length_documento()){
                    await this.data.AsyncGetFromValue(this.data.api.cliente,'documento',this.cliente.documento).then(r=>{
                        try{
                            console.log(r);
                            if(r.idcliente == undefined || r.idcliente == ''){
                                if(parseInt(this.cliente.tipodocide) == 1 || parseInt(this.cliente.tipodocide) == 6){ this.isbtnsunat = true; this.isdisabled=true; }else{this.isbtnsunat = false; this.isdisabled= false;}
                                
                               this.isdisabled_documento = true;
                                this.isbtnvalida = false;
                                this.notify.Notify(1,'Número de documento válido para el registro.');
                            }else{
                                this.data.notify('Estimado(a), el número de documento ya está registrado, intente con otro número. Gracias.','Advertencia',this.data.alertType.warning,new ALertOption(false,false,'Aceptar'));
                            }
                        } catch(ex){console.log(ex);}
                    });
                }
            }else{
                this.data.notify('Estimado(a), tienes que ingresar el número de documento','Advertencia',this.data.alertType.warning,new ALertOption(false,false,'Aceptar'));
            }
            
        }
        
    }

    public async searchSunat(){
        this.data.wait('Espere por favor, estamos buscando el número de documento en SUNAT','Buscando Número');
        await this.data.Consulta('ruc',this.cliente.documento).then(r=>{
            this.data.notifyClose();
            try{
                if(r.result > 0){
                    this.cliente.nombre = r.message.razon_social;
                    this.cliente.direccion = r.message.domicilio_fiscal;
                    this.isdisabled= false;
                    this.isbtnsunat = false;
                }else{
                    this.isdisabled =true;
                    this.data.notify('Estimado(a), Número de documento no encontrado en los registros de la SUNAT. ¿Desea continuar con el registro del cliente?','RUC no encontrado',this.data.alertType.error,new ALertOption(true,false,'Sí Continuar','No, Cerrar'),()=>{
                        this.isdisabled = false;
                        this.isdisabled_documento=true;
                        this.isbtnsunat = false;
                        
                    },()=>{
                        this.isdisabled = true;
                        this.isdisabled_documento = false;
                        this.isbtnsunat = false;
                        this.isbtnvalida = true;
                        this.cliente.documento = null;
                    });
                }
            }catch(ex){console.log(ex);}
            console.log(r);
        });
    }


    async GetDireccion(){
        await this.data.selectP(this.data.api.clientedireccion,'cliente',this.cliente.idcliente).then(r=>{
            if(r[0].id != ''){
                this.clientedirecciones = r;
                console.log(r);
            }else{this.clientedirecciones = [];}
            
        }).catch(e=>{console.log(e)});
    }

    public countp:number=0;
    generaDireccion(){
        let pr:ClienteDireccion[]=[];
        this.countp=0;
        if(this.clientedirecciones.length > 0){
            for (let item of this.clientedirecciones) {
                item.direccion = item.direccion != undefined ? item.direccion : null;
                item.n = this.countp.toString();
               // item.igv = '18';
                this.countp++;
                pr.push(item);
            }
        }
        let p:ClienteDireccion = new ClienteDireccion();
        p.n = this.countp.toString();
        p.direccion = null;
        pr.push(p);
        
        this.clientedirecciones = pr;
    }

    async SaveItem(){
        if (!this.cliente.nombre && !this.cliente.documento && !this.cliente.zona_ubigeo) {
            this.data.notify("Faltan datos","Atencion",this.data.alertType.info)
        }else{
            if(this.iseditable){//modificar
                this.cliloading.show('modificando datos');
                await this.data.AsyncPut(this.data.api.cliente ,this.cliente.idcliente,this.cliente).then( async a=>{
                    if(a.status == 'success'){
                        
                        if(this.funcion != undefined){this.funcion();}
                        this.data.notify('','Registro Guardado',this.data.alertType.success,new ALertOption(),()=>{
                            this.close();
                        });
                    }else{
                        this.data.notify('Error','Error al guardar registro',this.data.alertType.error,new ALertOption());
                    }
                }).catch(e=>{console.log(e);}) ;
                this.cliloading.hide();
    
            }else{//insert new
                this.cliloading.show('registrando Nuevo');
                await this.data.AsyncPost(this.data.api.cliente,this.cliente).then( async a=>{
                   console.log();
                    if(a.idcliente){
                        // for (let clientedireccion of this.clientedirecciones) {
                        //     clientedireccion.cliente.idcliente = a.message.idcliente;
    
                        //     await this.data.insertP(this.data.api.clientedireccion,clientedireccion).then(async b =>{
                        //     }).catch(e=>{console.log(e.error.text)});
                        // }
                        if(this.funcion != undefined){this.funcion();}
                        this.cliente = new Cliente();
                        this.isbtnsunat = false;
                        this.isbtnvalida= true;
                        this.isdisabled_documento=false;
                        this.isdisabled = true;
                        this.data.notify('Exito','Registro Guardado',this.data.alertType.success,new ALertOption(),()=>{this.close();});
                    }else{
                        this.data.notify('Error','Error al registrar cliente',this.data.alertType.error,new ALertOption());
                    }
                }).catch(e=>{this.data.notify('Error al registrar cliente','Error',this.data.alertType.error,new ALertOption());}) ;
                this.cliloading.hide();
            }
        }
    }

    async DeleteItem(i){
        this.data.notify('Estimado(a), ¿Estas seguro de eliminar la dirección seleccionada?','Eliminar dirección',this.data.alertType.question,new ALertOption(true,true,'Sí, Eliminar','No, Cerrar'),async ()=>{
                
            await this.data.AsyncDelete(this.data.api.clientedireccion,this.clientedireccion.id).then((r)=>{
                if(r.result > 0){
                  this.data.notify(r.message,'Registro Eliminado',this.data.alertType.success,new ALertOption());
                }else{
                 this.data.notify(r.message,'Error al eliminar',this.data.alertType.error,new ALertOption());
                }
                 this.GetDireccion();
             }).catch((e)=>{console.log(e)});
         });
        
    }

    close() { this.btnclosepg.nativeElement.click(); }

}
